export const Color = {
  Dark: 'dark',
  Light: 'light',
} as const;
